import { useState } from 'react';
import { useVersionSynced } from '@/context/VersionSyncContext';
import { useAppVersionConfig } from '@/hooks/useAppVersionConfig';
import { isNativeWebView } from '@/utils/nativeBridge';
import { detectMobilePlatform } from '@/utils/calendarExport';
import './UpdateRequiredModal.css';

// Shows an "update available" nudge whenever native hasn't confirmed it's on
// a version that's in sync (versionSynced === true). Current (pre-this-
// feature) native builds never send that confirmation at all, so they fall
// through to "show the modal" by default — exactly the members we need to
// reach. Renders nothing outside the native WebView (nothing to sync there).
export default function UpdateRequiredModal() {
  const versionSynced = useVersionSynced();
  const { config } = useAppVersionConfig();
  const [dismissed, setDismissed] = useState(false);

  if (!isNativeWebView()) return null;
  if (versionSynced) return null;
  if (!config?.enabled) return null;

  const platform = detectMobilePlatform();
  if (platform !== 'ios' && platform !== 'android') return null;

  const platformConfig = config[platform];
  const isForced = platformConfig.force;
  if (dismissed && !isForced) return null;

  const handleUpdate = () => {
    window.open(platformConfig.storeUrl, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="urm-overlay">
      <div className="urm-modal">
        <h2 className="urm-title">Update Available</h2>
        <p className="urm-message">
          {isForced
            ? 'A new version of Tee Box is required to continue using the app.'
            : 'A new version of Tee Box is available with the latest features and fixes.'}
        </p>
        <button className="urm-btn urm-btn--primary" onClick={handleUpdate}>
          Update Now
        </button>
        {!isForced && (
          <button className="urm-btn urm-btn--ghost" onClick={() => setDismissed(true)}>
            Later
          </button>
        )}
      </div>
    </div>
  );
}
